export const PIP_SKINS = [
  { value: 'default', labelKey: 'settings.pipSkinDefault' },
  { value: 'game-hud', labelKey: 'settings.pipSkinHud' },
  { value: 'orbis', labelKey: 'settings.pipSkinOrbis' },
  { value: 'sakura', labelKey: 'settings.pipSkinSakura' },
  { value: 'arcane', labelKey: 'settings.pipSkinArcane' },
] as const

export type PipSkin = typeof PIP_SKINS[number]['value']

export function defaultPipColors(dark: boolean) {
  return dark
    ? { bg: '#111317', surface: '#1a1d24', subtle: '#252a34', text: '#f8fafc', muted: '#94a3b8', border: '#2e3542', danger: '#f87171', dangerSoft: '#3b1c1c', green: '#34d399', greenSoft: '#132e23', exp: '#fbbf24', mesos: '#fb923c', amber: '#fbbf24', amberSoft: '#382d16', hp: '#fb7185', mp: '#38bdf8' }
    : { bg: '#f5f7fa', surface: '#ffffff', subtle: '#edf2f7', text: '#0f172a', muted: '#64748b', border: '#e2e8f0', danger: '#dc2626', dangerSoft: '#fef2f2', green: '#059669', greenSoft: '#ecfdf5', exp: '#b45309', mesos: '#c2410c', amber: '#d97706', amberSoft: '#fffbeb', hp: '#e11d48', mp: '#0284c7' }
}

export function normalizePipSkin(value: unknown): PipSkin {
  return PIP_SKINS.find((skin) => skin.value === value)?.value ?? 'default'
}
